import { Component, Input } from '@angular/core';

import { trackByProp } from '@recruitee/common';

import { IconColor } from '../../common/icon/icon.component';

export interface CandidatesAvatars {
  name: string;
  emails: string[];
  id: number;
  photoThumbUrl: string;
}

@Component({
  selector: 'rt-candidates-avatars',
  templateUrl: './candidates-avatars.component.html',
  styleUrls: ['./candidates-avatars.component.less'],
})
export class CandidatesAvatarsComponent {
  @Input() public candidates?: CandidatesAvatars[] = [];

  public IconColor = IconColor;

  public trackByCandidate = trackByProp<CandidatesAvatars>({ prop: 'id' });
}
